import {BaseElement} from "./baseElement.ts";
import {Box} from "../layout/box.ts";
import type {jsPDF} from "jspdf";

export class Line extends BaseElement {
	kind = "line" as const;
	color: string;

	constructor(box: Box, id: string, color: string) {
		super(box, id);
		this.color = color;
	}

	async draw(pdfDocument: jsPDF): Promise<void> {
		const box = this.box.getBoundingBox();
		pdfDocument.setDrawColor(this.color);
		pdfDocument.setLineWidth(this.box.size.height);
		pdfDocument.line(box.x, box.y, box.width + box.x, box.y);
	}
}
